import React, { Component, Fragment } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Checkbox from "rc-checkbox";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";

class Top20Content extends Component {
  state = {
    regions: ["all"],
  };

  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    let columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: url.split("/")[2],
        },
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "viewers",
        text: "Unique Viewers",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "min_watched",
        text: "Min Time Watched",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    // First Look Media Topic does not have
    if (url.includes("p=firstlookmedia-topic")) {
      columns.splice(2, 1);
    }

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  onChangeAll = (e) => {
    this.setState({
      regions: ["all"],
    });
  };

  onChange = (e) => {
    let NAME = e.target.name;
    e.target.checked ? this.addItem(NAME) : this.removeItem(NAME);
  };

  addItem = (item) => {
    this.setState({
      regions: [...this.state.regions.filter((i) => i !== "all"), item],
    });
  };

  removeItem = (item) => {
    const REGIONS = this.state.regions.filter((i) => i !== item);
    this.setState({
      regions: REGIONS.length === 0 ? ["all"] : REGIONS,
    });
  };

  renderFilters = (data) => {
    const REGIONS_ARRAY = [...new Set(data.map((o) => o.region))];

    if (REGIONS_ARRAY.length === 1) return null;

    const checkboxes = REGIONS_ARRAY.map((item, key) => (
      <label key={key} className="filters__checkbox_label">
        <Checkbox
          name={item}
          checked={this.state.regions.includes(item)}
          onChange={this.onChange}
        />
        <span className="filters__checkbox_label-text">{item}</span>
      </label>
    ));

    return (
      <div className="row">
        <div className="col-12">
          <section className="filters">
            <label className="filters__checkbox_label">
              <Checkbox
                name="all"
                checked={this.state.regions.includes("all")}
                onChange={this.onChangeAll}
              />
              <span className="filters__checkbox_label-text">Everything</span>
            </label>
            {checkboxes}
          </section>
        </div>
      </div>
    );
  };

  sortByViews = (data) => {
    const _data = {};
    data.forEach((d) => {
      if (typeof _data[d.title] === "undefined") {
        const _d = { title: d.title, image_url: d.image_url };
        _d.views = Object.assign({}, d.views);
        _d.viewers = Object.assign({}, d.viewers);
        _d.min_watched = Object.assign({}, d.min_watched);

        _data[d.title] = _d;
      } else {
        const _d = _data[d.title];

        _d.views.previous += d.views.previous;
        _d.views.value += d.views.value;

        _d.viewers.previous += d.viewers.previous;
        _d.viewers.value += d.viewers.value;

        _d.min_watched.previous += d.min_watched.previous;
        _d.min_watched.value += d.min_watched.value;
      }
    });
    const aggregatedData = Object.keys(_data).map((title) => _data[title]);
    aggregatedData.forEach((d) => {
      d.views.change =
        d.views.previous > 0
          ? (d.views.value - d.views.previous) / d.views.previous
          : 0;
      d.views.direction = d.views.change >= 0 ? "up" : "down";

      d.viewers.change =
        d.viewers.previous > 0
          ? (d.viewers.value - d.viewers.previous) / d.viewers.previous
          : 0;
      d.viewers.direction = d.viewers.change >= 0 ? "up" : "down";

      d.min_watched.change =
        d.min_watched.previous > 0
          ? (d.min_watched.value - d.min_watched.previous) /
            d.min_watched.previous
          : 0;
      d.min_watched.direction = d.min_watched.change >= 0 ? "up" : "down";
    });

    return aggregatedData
      .sort((a, b) => b.views.value - a.views.value)
      .slice(0, 20);
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let table_data = data.data;

    if (this.state.regions.includes("all")) {
      table_data = this.sortByViews(table_data);
    } else {
      let filters = this.state.regions;
      table_data = data.data.filter((o) => filters.includes(o.region));
      table_data = this.sortByViews(table_data);
    }

    return (
      <Fragment>
        {this.renderFilters(data.data)}
        {this.renderTable(table_data)}
      </Fragment>
    );
  }
}

export default Top20Content;
